import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNotify, useRedirect,useRefresh,useUnselectAll } from 'react-admin';


  const AlertDialogConfirmation = (props,...rest)=> {
  const [open, setOpen] = useState(false);
  const {affiche,titre,message,redirectOui,idDetFact,handleDeleteConfirm,resource}=props;
  const notify = useNotify();
  const redirect = useRedirect();

  const refresh = useRefresh();
  const unselectAll = useUnselectAll(resource);

  //const refresh = useRefresh();
  useEffect(() => {
    setOpen(affiche);
  }, [affiche])
 

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgree = () => {   
    handleClose();   

    const config = {
      method: 'DELETE',
      url:  process.env.REACT_APP_URL + '/'+resource+'/'+idDetFact,
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Bearer "+ localStorage.getItem('token')
      }
    };

    axios(config).then(function (response) {
                if(response.data.status==='success'){
                  notify(response.data.message);
                  refresh();
                  redirect(redirectOui); 
                  
                  window.location.reload();
                  //setOpenDeleteConfirm(false);
                }else{
                  notify(response.data.message,'warning');
                }

          })
          .catch(function (error) {
              notify(error.message,'warning');
          });

 
  };

  const handleDisagree = () => {
    handleDeleteConfirm();

    //redirect(props.redirectNon);
  };
  //<Button onClick={handleClickOpen} color="primary" startIcon={<Assignment />}>Etiquette</Button>
  
    return (
      <span>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {titre}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDisagree} color="primary" startIcon={<ThumbDown />}>
              Non
            </Button>
            <Button onClick={handleAgree} color="primary" autoFocus startIcon={<ThumbUp />}>
              Oui
            </Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  
}

export default AlertDialogConfirmation;
